namespace $ {

	$mol_style_define($bog_music_nav, {
		flex: { direction: 'row' },
		padding: {
			top: '0.375rem',
			bottom: '0.375rem',
			left: '0.5rem',
			right: '0.5rem',
		},
		gap: '0.25rem',
		background: { color: $bog_builderui_tokens.card },
		border: { top: { width: '1px', style: 'solid', color: $bog_builderui_tokens.line } },
	})

}
